import { Link } from 'react-router-dom';
import { LANDING } from '@/constants/testIds';
import { ArrowRight } from 'lucide-react';
import LogoMark from './LogoMark';

const CTASection = () => {
  return (
    <>
      <section
        id="cta"
        data-testid={LANDING.ctaSection}
        className="relative py-32 md:py-44"
      >
        {/* Section divider line */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-signal-gold/40 to-transparent" />

        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <h2
            data-testid={LANDING.ctaHeadline}
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-bone tracking-tight max-w-3xl mx-auto leading-[1.15]"
          >
            Train the system that feeds the brain and body.
          </h2>

          <div className="mt-12">
            <a
              data-testid={LANDING.ctaBtn}
              href="https://app.visiq.es"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-bone text-void font-body font-medium px-10 py-4 rounded-none hover:bg-signal-gold transition-colors duration-300 group"
            >
              Get started
              <ArrowRight size={18} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        data-testid={LANDING.footer}
        className="border-t border-white/5 py-10"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2.5">
            <LogoMark size={20} />
            <span className="font-heading text-lg font-semibold text-bone tracking-tight">
              Vis<span className="text-signal-gold">IQ</span>
            </span>
          </div>
          <div className="flex items-center gap-8">
            <Link
              to="/partnerships"
              data-testid="footer-partnerships-link"
              className="font-body text-xs text-slate hover:text-bone transition-colors duration-300"
            >
              Partnerships
            </Link>
            <a
              href="mailto:hello@visiq.es"
              className="font-body text-xs text-slate hover:text-bone transition-colors duration-300"
            >
              hello@visiq.es
            </a>
          </div>
          <p className="font-mono text-slate text-xs tracking-wider">
            &copy; {new Date().getFullYear()} VisIQ. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default CTASection;
